export default __webpack_public_path__ + "static/media/sample-probono2.89dc9158.png";